import React from "react";
import { Link } from "react-router-dom";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import { useTranslation, Trans } from "react-i18next"; // ✅ import i18n hook

const SummarySection = ({ currentQuestionIndex }) => {
  const { propertyInfo } = usePropertyStore();
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-secondary h-full w-[300px] pt-10 pl-10 pr-5 min-h-[calc(100vh-4rem)] overflow-y-scroll">
        <h2 className="text-2xl font-bold text-white">{t("summary")}</h2>

        <hr className="border-white w-full my-4" />
        {propertyInfo && (
          <div>
            <ul className="text-white font-medium text-lg list-disc">
              {currentQuestionIndex >= 0 && (
                <li>
                  {t("location")}:{" "}
                  {propertyInfo?.location?.address
                    ? propertyInfo?.location?.address
                    : ""}
                  .
                </li>
              )}

              {currentQuestionIndex >= 0 &&
                (propertyInfo?.calculatedSize &&
                  propertyInfo?.calculatedSize?.size?.length > 0 ? (
                  <li>
                    {t("space")}: {propertyInfo?.calculatedSize?.size[0]}m² -{" "}
                    {propertyInfo?.calculatedSize?.size[1]}m² {t("added")}.
                  </li>
                ) : (
                  ""
                ))}

              {currentQuestionIndex >= 0 &&
                (propertyInfo?.calculatedSize &&
                  propertyInfo?.calculatedSize?.size?.length > 0 ? (
                  <li>
                   {t("number_of_people")}: {propertyInfo?.calculatedSize?.size[0] ? `${propertyInfo?.employeesPerArea} m²/person.` : 0}
                  </li>
                ) : (
                  ""
                ))
              }

              {currentQuestionIndex >= 1 && (
                <li>{t("plan_to_move")}: {propertyInfo?.movePlan?.answer}</li>
              )}

              {currentQuestionIndex >= 2 && (
                <li>{t("budget_pricing")}: {propertyInfo?.budgetPricing?.answer}</li>
              )}

              {currentQuestionIndex >= 3 && (
                <li>
                 {t("preferred_location")}: {propertyInfo?.preferredLocation?.answer}
                </li>
              )}
              {currentQuestionIndex >= 4 && (
                <li>{t("office_type")}: {propertyInfo?.officeType?.answer}</li>
              )}
              {currentQuestionIndex >= 5 && (
                <li>{t("lease_duration")}: {propertyInfo?.leaseDuration?.answer}</li>
              )}
              {/* {currentQuestionIndex >= 6 && (
                <li>Office spaces: {propertyInfo?.officeSpaces?.answer}</li>
              )}
              {currentQuestionIndex >= 7 && (
                <li>Amenities: {propertyInfo?.amenities?.answer}</li>
              )} */}
              {currentQuestionIndex >= 6 && (
                <li>{t("parking")}: {propertyInfo?.parking?.answer}</li>
              )}
            </ul>
          </div>
        )}

        {/* <div className="mt-6">
        <Link to="/map-view">
          <button className="bg-white text-primary-text px-5 py-3 rounded-[58px] font-semibold">
            Floor Plan
          </button>
        </Link>
      </div> */}
      </div>
    </>
  );
};

export default SummarySection;
